<template>
    <div class="release-popup" :class="{ active: popupModalIsActive }">
        <div class="release-popup-heading">
            <h4>Nytt i Falagrett</h4>
            <div class="close-release-popup-icon" @click="closePopup">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                        stroke="black"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M15 9L9 15"
                        stroke="black"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M9 9L15 15"
                        stroke="black"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>
        </div>

        <div class="release-popup-features">
            <ReleaseFeature
                v-for="(feature, index) in featuresList"
                :key="index"
                :feature="feature"
                :class="{ active: activeStep === index + 1 }"
            >
                <span class="release-popup-steps">
                    <button :disabled="activeStep === 1" @click="goBack">
                        <VueFeather type="arrow-left" :size="16" />
                    </button>
                    <span>{{ activeStep }} av {{ maximumStep }}</span>
                    <button :disabled="activeStep === maximumStep" @click="handleNextStep">
                        <VueFeather type="arrow-right" :size="16" />
                    </button>
                </span>
            </ReleaseFeature>
        </div>
        <div class="release-popup-actions">
            <button class="btn btn--cta" @click="handleNextStep">
                {{ activeStep === maximumStep ? 'Stäng' : 'Nästa' }}
            </button>
            <button class="btn btn--txt btn--read-later" @click="closeWithoutSaving">Läs senare</button>
        </div>
    </div>
    <div v-if="popupModalIsActive" class="release-popup-backdrop"></div>
</template>

<script setup>
    import { provide, ref } from 'vue';
    import { useStore } from 'vuex';
    import VueFeather from 'vue-feather';
    import ReleaseFeature from './ReleaseFeature.vue';

    const store = useStore();

    const popupModalIsActive = ref(false);
    const activeStep = ref(1);
    const maximumStep = ref(3);
    const featuresList = ref([]);
    const showPopup = () => {
        store.dispatch('UserReleaseFeaturesStore/getFeatures').then((response) => {
            if (response.data.features != null) {
                featuresList.value = response.data.features;
                maximumStep.value = response.data.features.length;
                popupModalIsActive.value = true;
            }
        });
    };
    showPopup();

    const handleNextStep = () => {
        if (activeStep.value === maximumStep.value) {
            closePopup();
        } else {
            activeStep.value++;
        }
    };
    const goBack = () => {
        activeStep.value--;
    };

    const closeWithoutSaving = () => {
        popupModalIsActive.value = false;
    };

    const closePopup = () => {
        popupModalIsActive.value = false;
        store.dispatch('UserReleaseFeaturesStore/viewFeatures');
    };

    provide('featureChanged', activeStep);
</script>
